// extracted by css-extract-rspack-plugin
export default {"container":"container-OrMgno","row":"row-cNSXHV","column":"column-FOIOU8","label":"label-9y_poI","labelError":"labelError-Jd4reK","icon":"icon-ZEKBZF"};